import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChartCardSkeleton = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "100%",
	height: "100%",
	viewBox: "0 0 614 352",
	preserveAspectRatio: "none",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M42 3L42 314",
			stroke: "#EEEEEE",
			strokeWidth: 5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M607 314L42 314",
			stroke: "#EEEEEE",
			strokeWidth: 5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 10,
			width: 28,
			height: 19,
			rx: 6.89193,
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 151,
			width: 28,
			height: 19,
			rx: 6.89193,
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 1,
			y: 292,
			width: 28,
			height: 19,
			rx: 6.89193,
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 81,
			width: 28,
			height: 19,
			rx: 6.89193,
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 222,
			width: 28,
			height: 19,
			rx: 6.89193,
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 45,
			width: 28,
			height: 20,
			rx: 6.89193,
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 186,
			width: 28,
			height: 20,
			rx: 6.89193,
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 1,
			y: 328,
			width: 28,
			height: 19,
			rx: 6.89193,
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 116,
			width: 28,
			height: 19,
			rx: 6.89193,
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 257,
			width: 28,
			height: 19,
			rx: 6.89193,
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 42,
			y: 330,
			width: 28,
			height: 19,
			rx: 6.89193,
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 251,
			y: 330,
			width: 29,
			height: 19,
			rx: 6.89193,
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 147,
			y: 330,
			width: 28,
			height: 19,
			rx: 6.89193,
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 328,
			y: 330,
			width: 29,
			height: 19,
			rx: 6.89193,
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 585,
			y: 330,
			width: 29,
			height: 19,
			rx: 6.89193,
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 477,
			y: 330,
			width: 28,
			height: 19,
			rx: 6.89193,
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 77,
			y: 330,
			width: 28,
			height: 19,
			rx: 6.89193,
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 286,
			y: 330,
			width: 29,
			height: 19,
			rx: 6.89193,
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 181,
			y: 330,
			width: 29,
			height: 19,
			rx: 6.89193,
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 372,
			y: 330,
			width: 28,
			height: 19,
			rx: 6.89193,
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 511,
			y: 330,
			width: 29,
			height: 19,
			rx: 6.89193,
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 112,
			y: 330,
			width: 28,
			height: 19,
			rx: 6.89193,
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 442,
			y: 330,
			width: 28,
			height: 19,
			rx: 6.89193,
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 216,
			y: 330,
			width: 29,
			height: 19,
			rx: 6.89193,
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 407,
			y: 330,
			width: 28,
			height: 19,
			rx: 6.89193,
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 546,
			y: 330,
			width: 29,
			height: 19,
			rx: 6.89193,
			fill: "#EEEEEE"
		})
	]
});
export default SvgChartCardSkeleton;
